import React from 'react';
import { Box, Typography } from '@mui/material';
import { KeywordAnalyzer }    from './KeywordAnalyzer.jsx';
import { EpisodeOptimizer }   from './EpisodeOptimizer.jsx';
import { HealthCheck }        from './HealthCheck.jsx';
import { ContactOwner }       from './ContactOwner.jsx';
import { SocialAudit }        from './SocialAudit.jsx';
import { CadenceFormat }      from './CadenceFormat.jsx';
import { ThemeMap }           from './ThemeMap.jsx';
import { Op3Downloads }       from './Op3Downloads.jsx';
import { SponsorSuggestions } from './SponsorSuggestions.jsx';
import { SponsorFinder }      from './SponsorFinder.jsx';
import { CategoryThemes }     from './CategoryThemes.jsx';
import { GuestExtractor }     from './GuestExtractor.jsx';
import { SocialScan }         from './SocialScan.jsx';
import { ContactResearch }    from './ContactResearch.jsx';

const MODULE_COMPONENTS = {
  keyword_analyzer:     KeywordAnalyzer,
  episode_optimizer_v2: EpisodeOptimizer,
  health_check_v2:      HealthCheck,
  contact_owner:        ContactOwner,
  social_audit:         SocialAudit,
  cadence_v2:           CadenceFormat,
  theme_map_v2:         ThemeMap,
  op3_downloads:        Op3Downloads,
  sponsor_suggestions:  SponsorSuggestions,
  sponsor_finder:       SponsorFinder,
  category_themes:      CategoryThemes,
  guest_extractor:      GuestExtractor,
  social_scan_v2:       SocialScan,
  contact_research:     ContactResearch,
};

export function renderModuleOutput(moduleId, data) {
  if (!data) return null;

  const Component = MODULE_COMPONENTS[moduleId];
  if (Component) return <Component data={data} />;

  return (
    <Box sx={{ textAlign: 'center', py: 5 }}>
      <Typography sx={{ fontSize: 40, mb: 2 }}>📊</Typography>
      <Typography sx={{ fontWeight: 600, color: '#e4e4e7' }}>Module not found</Typography>
    </Box>
  );
}
